import { Typography as OriginTypography } from 'antd';
import Editable from 'antd/es/typography/Editable';
export { Editable };
export default OriginTypography;
